export default __webpack_public_path__ + "static/media/Ramnyr.f0528cb6.jpg";